package games.polyclub.website.frontend.store.hooks

import games.polyclub.frontend.lib.react.ga4.GA4
import games.polyclub.frontend.lib.react.simplified.SFC
import js.core.Object
import js.core.jso
import react.ComponentType
import react.FC
import react.Props
import react.router.useLocation
import react.useEffectOnce

fun withTracker(wrappedComponent: ComponentType<*>, title: String, options: dynamic = jso()): FC<Props> {
    fun trackPage(page: String) {
        GA4.set(jso {
            this.page = page
            this.title = title
            Object.assign(unsafeCast<Any>(), options)
        })
        GA4.send(jso {
            this.hitType = "pageview"
            this.page = page
            this.title = title
        })
    }

    return SFC {
        val location = useLocation()
        //useEffect(location.pathname, location.search) {
        useEffectOnce {
            trackPage(location.pathname + location.search)
        }

        wrappedComponent()
    }
}
